import { useQuery, useMutation } from '@tanstack/react-query'
import { Box, Button, Heading, Spinner, Text } from '@n26/nxd'
import { getCockpitDashboard } from '@/features/dashboard/api/cockpitDashboard'
import { pingManagerium } from '@/features/dashboard/api/managerium'

export const DashboardPage = () => {
  const { data, isPending, isError } = useQuery({
    queryKey: ['cockpitDashboard'],
    queryFn: getCockpitDashboard,
    enabled: import.meta.env.DEV,
  })

  const manageriumPing = useMutation({ mutationFn: pingManagerium })

  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      height='full'
      gap='16'
    >
      <Heading level={1}>lionfish is here</Heading>

      <Button
        variant='secondary'
        color='teal'
        loading={manageriumPing.isPending}
        onClick={() => manageriumPing.mutate()}
      >
        Ping managerium
      </Button>
      {manageriumPing.isSuccess && (
        <Text>Managerium says: {manageriumPing.data}</Text>
      )}
      {manageriumPing.isError && (
        <Text color='rhubarb'>Couldn&apos;t reach managerium.</Text>
      )}

      {isPending && <Spinner />}
      {isError && (
        <Text color='rhubarb'>Couldn&apos;t load the cockpit dashboard.</Text>
      )}
      {data && (
        <Text>
          Loaded &quot;{data.name}&quot; (dashboard {data.dashboardId}, instance{' '}
          {data.instance}): {data.cards.length} cards. Last updated{' '}
          {data.lastUpdated ?? 'never'}.
        </Text>
      )}
    </Box>
  )
}
